import { withGTM } from '@/features/shared/HOCs';
import { isEqual } from 'lodash';
import React from 'react';
import { BannerRibbon } from './BannerRibbon';
import {
  mapTarget,
  onDatalayer,
  onDatalayerClose,
  onDatalayerExitPopup,
  onDatalayerNew,
} from './NewsRibbon.datalayer';
import { NewsRibbonProps } from './NewsRibbon.interface';
import { SimpleRibbon } from './SimpleRibbon';

const mapPropsToComponent = ({
  bodyBanner,
  template,
}: {
  bodyBanner?: string;
  template?: string;
}) => {
  if (Boolean(bodyBanner) || /genetecweb:simple/.test(template || '')) return SimpleRibbon;

  return BannerRibbon;
};

export const NewsRibbonComponent = React.memo(
  (props: Br.PropsWithContentButtons<NewsRibbonProps>) => {
    const Variant = React.useMemo(
      () => mapPropsToComponent({ bodyBanner: props.bodyBanner, template: props.template }),
      [props.bodyBanner, props.template],
    );

    return <Variant {...props} />;
  },
  isEqual,
);

const NewsRibbonLegacy = withGTM({
  Component: NewsRibbonComponent,
  onDatalayer,
  config: { mapTarget },
});
const NewsRibbonNew = withGTM({
  Component: NewsRibbonLegacy,
  onDatalayer: onDatalayerNew,
  config: { mapTarget },
});
const NewsRibbonDataLayerClose = withGTM({
  Component: NewsRibbonNew,
  onDatalayer: onDatalayerClose,
  config: { eventName: 'gtm:bannerribbon:close', isCustom: true },
});

const NewsRibbonDataLayerExitPopup = withGTM({
  Component: NewsRibbonDataLayerClose,
  onDatalayer: onDatalayerExitPopup,
  config: { eventName: 'gtm:bannerribbon:close', isCustom: true },
});

export default React.memo(NewsRibbonDataLayerExitPopup);
